import React from "react";
import { Box } from "@mui/material";
import SubTitle from "../../components/common/SubTitle";
import AppSettings from "../../components/appSettings/AppSettings";
import TitleBar from "../../components/navbar/TitleBar";
import Footer from "../../components/common/Footer";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";

export default function SchoolSettingsContainer() {
  return (
    <>
      <Box>
        <TitleBar />
        <SchoolBusNavMenu />
        <SubTitle title="Settings" />
        <AppSettings school={true} />
      </Box>
      <Footer />
    </>
  );
}
